import axios from "axios";

// Get Customer subscription information route
const API_GET_CUSTOMER_SUB = '/api/sub/getCustomerSubscription'

//Basic tier routes
const API_CREATE_MONTHLY_BASIC_SUBSCRIPTION = '/api/sub/createMonthlyBasicSubscription'

//Pro tier routes
const API_CREATE_MONTHLY_PRO_SUBSCRIPTION = '/api/sub/createMonthlyProSubscription'

//Cancel route
const API_CANCEL_SUB = '/api/sub/cancelSubscription'

//Restart subscription for an existing user. 
const API_RESTART_SUBSCRIPTION_DATA = '/api/sub/restartSubscription';


//Get the customer's subcription details
const getSubscription = async (token) => {
   
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };

    try {
        const response = await axios.get(API_GET_CUSTOMER_SUB, config);
        return response.data;
    } catch (error) {
        console.warn("No active subscription found for the user", error.response?.data || error.message);
        throw error;
    }
}

//start monthly good tier subsciption
const startBasicMonthly = async (token) => {
   
    const response = await axios.post(API_CREATE_MONTHLY_BASIC_SUBSCRIPTION, {}, {
        headers: { Authorization: `Bearer ${token}` }
    });

    return response.data
}

//start BEST monthly subscription
const startProMonthly = async (token) => {
   
    try {
        const response = await axios.post(API_CREATE_MONTHLY_PRO_SUBSCRIPTION, {}, {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (error) {
        console.error("Error in startProMonthly:", error.response?.data || error.message);
        throw error;
    }
}

//cancel subscription
const cancelSub = async (token, subId) => {
    

    const response = await axios.post(API_CANCEL_SUB, {
        subId
    }, {
        headers: { Authorization: `Bearer ${token}` }
    });

    return response.data
}

//restart subscription 
//restart subscription
const restartSubscription = async(restartSubscriptionData, token) =>{
    const response = await axios.post(API_RESTART_SUBSCRIPTION_DATA, restartSubscriptionData, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return response.data
}

const siteService = {
    getSubscription,
    startBasicMonthly,
    startProMonthly,
    cancelSub,
    restartSubscription,
}

export default siteService